import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export type { CollapsibleContentProps, CollapsibleProps, CollapsibleTriggerProps } from "@radix-ui/react-collapsible";
export { Collapsible, CollapsibleContent, CollapsibleTrigger };
